import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CreateUpdateReplyRequest, Reply } from '@shared/reply/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class ReplyApiService {
  private readonly basePath = '/v.1/reply';

  constructor(
    private readonly http: ApiClientService,
  ) {
  }

  getList(): Observable<Reply[]> {
    return this.http.get<Reply[]>(this.basePath);
  }

  create(data: CreateUpdateReplyRequest): Observable<Reply> {
    return this.http.post<Reply>(this.basePath, data);
  }

  updateById(id: string, data: CreateUpdateReplyRequest): Observable<Reply> {
    return this.http.put<Reply>(`${this.basePath}/${id}`, data);
  }

  delete(id: string): Observable<Reply> {
    return this.http.delete<Reply>(`${this.basePath}/${id}`);
  }
}
